
import './App.css';
import '@fontsource/roboto/500.css';

function Aboutus() {
  return (
    <>

<section class="hero">
    <div class="container">
        <h1>About LabourChowk.in</h1>
        <p class="lead mt-3">
            Connecting skilled, unskilled workers with employers through a trusted,
            transparent, and technology-driven platform.
        </p>
    </div>
</section>

<section class="section">
<div class="container">

<div class="row align-items-center">

<div class="col-lg-6">
<h2 class="fw-bold mb-4">Who We Are</h2>

<p class="text-muted">
LabourChowk.in is a digital marketplace that simplifies the process of
finding reliable workers and connecting skilled labourers with genuine job
opportunities. We aim to bridge the gap between employers and workers by
making hiring faster, easier, and more transparent.
</p>

<p class="text-muted">
Whether someone needs a mason, electrician, plumber, carpenter, painter,
driver, helper, or other skilled professionals, LabourChowk.in helps them
find the right person quickly and efficiently.
</p>

<p class="text-muted">
  <p>The Founders are Sandeep Patil, Sachin Katiyar, Shweta Dekate, Raju Gupta.</p>
        
  {/* <img src="../../../../assets/img/founder/founder-2.jpeg" height="200px" alt="Founders 2" /> */}
  <img src="../../../../assets/img/founder/founder-3.png" height="100px" alt="Founders 3" /> &nbsp;
  <img src="../../../../assets/img/founder/founder-1.jpeg" height="100px" alt="Founders 1" />  &nbsp;
  <img src="../../../../assets/img/founder/founder-4.jpeg" height="100px" alt="Founders 4" /> &nbsp;

</p>

</div>

<div class="col-lg-6">

<div class="row g-4">

<div class="col-md-6">
<div class="card card-modern p-4">

<div class="icon-box">
<i class="bi bi-bullseye"></i>
</div>

<h4>Our Mission</h4>

<p class="text-muted">
To empower workers with better employment opportunities while helping
businesses and households hire trusted skilled professionals with ease.
</p>

</div>
</div>

<div class="col-md-6">
<div class="card card-modern p-4">

<div class="icon-box">
<i class="bi bi-eye-fill"></i>
</div>

<h4>Our Vision</h4>

<p class="text-muted">
To become India's most trusted digital labour marketplace that creates
economic opportunities for millions of skilled workers.
</p>



</div>
</div>

</div>

</div>

</div>

</div>
</section>

<section class="section bg-white">

<div class="container">
<img src="../../../../assets/img/vision/vision.png" className='img-fluid' height={800} alt="Call Icon" style={{ verticalAlign: 'middle', marginRight: 8 }} />  
<div class="text-center mb-5 p-5">
<h2 class="fw-bold">Why Choose LabourChowk.in?</h2>
<p class="text-muted">
Designed for both workers and employers.
</p>
</div>

<div class="row g-4">

<div class="col-md-3">
<div class="value-card">
<i class="bi bi-search text-primary fs-1"></i>
<h5 class="mt-3">Easy Search</h5>
<p class="text-muted">Find skilled workers quickly by location and trade.</p>
</div>
</div>

<div class="col-md-3">
<div class="value-card">
<i class="bi bi-shield-check text-success fs-1"></i>
<h5 class="mt-3">Trusted Platform</h5>
<p class="text-muted">A secure and transparent hiring experience.</p>
</div>
</div>

<div class="col-md-3">
<div class="value-card">
<i class="bi bi-clock-history text-warning fs-1"></i>
<h5 class="mt-3">Save Time</h5>
<p class="text-muted">Reduce hiring delays with faster connections.</p>
</div>
</div>

<div class="col-md-3">
<div class="value-card">
<i class="bi bi-people-fill text-danger fs-1"></i>
<h5 class="mt-3">Community</h5>
<p class="text-muted">Building opportunities for workers and employers.</p>
</div>
</div>

</div>

</div>

</section>


<section class="section stats">

<div class="container">

<div class="row text-center">

<div class="col-md-3">
<div class="stat-number">90+</div>
<p>Registered Workers</p>
</div>

<div class="col-md-3">
<div class="stat-number">50+</div>
<p>Employers</p>
</div>

<div class="col-md-3">
<div class="stat-number">80+</div>
<p>Skilled & Unskilled Mens</p>
</div>

<div class="col-md-3">
<div class="stat-number">24×7</div>
<p>Online Platform</p>
</div>

</div>

</div>

</section>


<section class="section">

<div class="container">

<div class="text-center mb-5">
<h2 class="fw-bold">Our Core Values</h2>
</div>

<div class="row g-4">

<div class="col-md-4">
<div class="card-modern p-4 text-center">
<i class="bi bi-heart-fill text-danger fs-1"></i>
<h4 class="mt-3">Trust</h4>
<p class="text-muted">
Building confidence between workers and employers.
</p>
</div>
</div>

<div class="col-md-4">
<div class="card-modern p-4 text-center">
<i class="bi bi-lightbulb-fill text-warning fs-1"></i>
<h4 class="mt-3">Innovation</h4>
<p class="text-muted">
Using technology to simplify hiring and job discovery.
</p>
</div>
</div>

<div class="col-md-4">
<div class="card-modern p-4 text-center">
<i class="bi bi-award-fill text-primary fs-1"></i>
<h4 class="mt-3">Quality</h4>
<p class="text-muted">
Delivering reliable services and meaningful opportunities.
</p>
</div>
</div>

</div>

</div>

</section>


<section class="footer-cta">

<div class="container">

<h2>Building India's Digital Labour Marketplace</h2>

<p class="lead mt-3">
Connecting skilled workers with opportunities and helping employers hire
with confidence.
</p>

<a href="#" class="btn btn-warning btn-lg mt-3 px-5">
Join LabourChowk.in
</a>

</div>

</section>

    </>    
  );
}

export default Aboutus;


